module.exports = __webpack_public_path__ + "media/5.f77b2e34.mp3";